import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'

export const GRID_DATE_FORMAT = 'YYYY-MM-DD'
export const GRID_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

/** 小于该阈值按秒时间戳解析，否则按毫秒（约 2001-09 前的 ms / 2286 前的秒） */
const MS_TIMESTAMP_THRESHOLD = 1e12

export function isDateColumnType(type?: string): type is 'date' | 'datetime' {
  return type === 'date' || type === 'datetime'
}

export function isTimestampValue(value: unknown): boolean {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return true
  }
  if (typeof value === 'string' && /^\d{10,13}$/.test(value.trim())) {
    return true
  }
  return false
}

export function parseGridDateValue(value: unknown): Dayjs | null {
  if (value == null || value === '') {
    return null
  }
  if (value instanceof Date) {
    const d = dayjs(value)
    return d.isValid() ? d : null
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    const d =
      Math.abs(value) < MS_TIMESTAMP_THRESHOLD
        ? dayjs.unix(value)
        : dayjs(value)
    return d.isValid() ? d : null
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (/^\d{10}$/.test(trimmed)) {
      const d = dayjs.unix(Number(trimmed))
      return d.isValid() ? d : null
    }
    if (/^\d{13}$/.test(trimmed)) {
      const d = dayjs(Number(trimmed))
      return d.isValid() ? d : null
    }
    const d = dayjs(trimmed)
    return d.isValid() ? d : null
  }
  return null
}

export function formatDateDisplayText(
  value: unknown,
  type: 'date' | 'datetime' = 'datetime'
): string {
  if (value == null || value === '') {
    return ''
  }
  const parsed = parseGridDateValue(value)
  if (!parsed) {
    return String(value)
  }
  return parsed.format(
    type === 'date' ? GRID_DATE_FORMAT : GRID_DATETIME_FORMAT
  )
}

/** 单元格已是时间戳时用 x，保证编辑回写仍为数字时间戳 */
export function resolveDateValueFormat(
  value: unknown,
  type: 'date' | 'datetime'
): string {
  if (isTimestampValue(value)) {
    return 'x'
  }
  return type === 'date' ? GRID_DATE_FORMAT : GRID_DATETIME_FORMAT
}
